import * as React from "react"
import PropTypes from "prop-types"

import Card from "../components/card"
import CardLoginButton from "../components/login/card-login-button"

const CardBlock = (props) => {
  const cardType = props.cardType
  const posts = props.posts
  const related = props.related
  const eagerLoadFirstTwo = props.eagerLoadFirstTwo || false

  return (
    <div className="cardBlock grid grid-cols-1 gap-3">
      {posts.map((post, index) => {
        const description = post.summary
        const slug = post.fields.slug
        const {
          hero,
          girls,
          tags,
          previewId,
          premium_4k,
          premium_lg,
          premium_sm,
          streamId,
          title,
          vid,
        } = post.frontmatter

        return (
          <div key={`card-block-${vid}`}>
            <CardLoginButton vid={vid} slug={slug} title={title} />
            <Card
              cardType={cardType}
              description={description}
              girls={girls}
              hero={hero}
              imageHost={props.imageHost}
              location={props.location}
              previewId={previewId}
              slug={slug}
              tags={tags}
              premium_4k={premium_4k}
              premium_lg={premium_lg}
              premium_sm={premium_sm}
              related={related}
              streamId={streamId}
              title={title}
              vid={vid}
              skipLazyLoading={eagerLoadFirstTwo && index < 2}
            />
          </div>
        )
      })}
    </div>
  )
}

CardBlock.propTypes = {
  cardType: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
  posts: PropTypes.array.isRequired,
  related: PropTypes.bool,
  imageHost: PropTypes.string,
  eagerLoadFirstTwo: PropTypes.bool
}

export default CardBlock
